(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["chameleon-nav-entry"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('chameleon-navigation')) {
  customElements.define('chameleon-navigation', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      const entry = this.querySelector('.cn-entry');
      const summary = entry.querySelector('summary');
      const desktop = this.classList.contains('cn-desktop-nav');
      const close = () => {entry.open = false;};
      if (desktop) {
        const categories = [...this.querySelectorAll('.cn-category')];
        const resize = () => {
          const dropdown = this.querySelector('.cn-dropdown');
          const available = Math.max(180,window.innerHeight-dropdown.getBoundingClientRect().top-12);
          this.style.setProperty('--cn-available-height',available+'px');
          this.style.setProperty('--cn-image-height',Math.max(72,Math.min(150,(available-200)/2))+'px');
          const panel = this.querySelector('.cn-category[open] .cn-panel');
          if (panel) this.querySelector('.cn-categories').style.minHeight = Math.max(panel.scrollHeight,220,categories.length*58)+'px';
        };
        categories.forEach(category => {
          const select = () => {categories.forEach(other => {other.open = other === category;});resize();};
          const heading = category.querySelector('summary');
          heading.addEventListener('click',event=>{event.preventDefault();select();},options);
          heading.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse')select();},options);
          heading.addEventListener('focus',select,options);
        });
        this.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse')entry.open=true;},options);
        this.addEventListener('pointerleave',event=>{if(event.pointerType==='mouse'&&!this.contains(document.activeElement))close();},options);
        entry.addEventListener('toggle',()=>{
          if(entry.open){document.querySelectorAll('.cn-desktop-nav .cn-entry').forEach(other=>{if(other!==entry)other.open=false;});resize();}
        },options);
        document.addEventListener('pointerdown',event=>{if(!this.contains(event.target))close();},options);
        this.addEventListener('focusout',event=>{if(!this.contains(event.relatedTarget))close();},options);
        window.addEventListener('resize',resize,options);
        this.observer = new ResizeObserver(resize);
        this.querySelectorAll('.cn-panel').forEach(panel=>this.observer.observe(panel));
      }
      this.addEventListener('keydown',event=>{if(event.key==='Escape'){close();summary.focus();event.stopPropagation();}},options);
    }
    disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();}
  });
}
  } catch(e) { console.error(e); }
})();

})();
